import { useEffect, useState, type ReactNode } from "react"

/**
 * Defers mounting of children until after the initial render frame completes.
 * Uses requestIdleCallback (with setTimeout fallback) to avoid blocking
 * first paint with non-critical initialization work.
 *
 * S8: Startup Performance Plan — defer non-critical hooks from AppLayout.
 */
export function DeferredMount({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if ("requestIdleCallback" in window) {
      const id = requestIdleCallback(() => setReady(true), { timeout: 1500 })
      return () => cancelIdleCallback(id)
    } else {
      const id = setTimeout(() => setReady(true), 100)
      return () => clearTimeout(id)
    }
  }, [])

  return ready ? <>{children}</> : null
}
